import {VideoPlayingServiceBase} from "./video-playing-service-base";
import {GameInfo} from "../games/game-info";
import {IVideoPlayer} from "./video-players/video-player.interface";

export const LIVE_STREAM_WATCH_TIME_LIMIT: number = 120000;

export class LiveStreamPlayingService extends VideoPlayingServiceBase {

    public gaCategory = "ORBIT_LIVE_STREAM";

    protected async _checkIfSupported() {
        const LiveStreamNativePlayer = await import(/* webpackChunkName: "live-stream-player-native"*/ './video-players/live-stream-players/native/video-live-stream-player-native').then(module => module.LiveStreamNativePlayer);
        if (LiveStreamNativePlayer.isSupported()) {
            return true;
        }

        const LiveStreamHlsPlayer = await import(/* webpackChunkName: "live-stream-player-hls"*/ './video-players/live-stream-players/hls/video-live-stream-player-hls').then(module => module.LiveStreamHlsPlayer);
        return LiveStreamHlsPlayer.isSupported();
    }

    async getVideoPlayer(gameInfo: GameInfo, videoReference: HTMLVideoElement, dontAutoSwipe?: boolean): Promise<IVideoPlayer> {

        const gameType = gameInfo.gameType;
        const streamSource = gameInfo.videoURL;

        if(gameInfo.slideCover){
            videoReference.poster = gameInfo.slideCover;
        }

        //In the future, this should be coming from admin as well.
        const watchTimeLimit = LIVE_STREAM_WATCH_TIME_LIMIT;

        const LiveStreamNativePlayer = await import(/* webpackChunkName: "live-stream-player-native"*/ './video-players/live-stream-players/native/video-live-stream-player-native').then(module => module.LiveStreamNativePlayer);

        // We need to check also if not android because Evo live stream games not working on android real device because they use WAF and they don't get referer in android native.
        if (LiveStreamNativePlayer.isSupported() && !this.services.device.os.isAndroid) {
            return new LiveStreamNativePlayer(this.services, gameType, videoReference, streamSource, watchTimeLimit);
        }

        const LiveStreamHlsPlayer = await import(/* webpackChunkName: "live-stream-player-hls"*/'./video-players/live-stream-players/hls/video-live-stream-player-hls').then(module => module.LiveStreamHlsPlayer);
        if (LiveStreamHlsPlayer.isSupported()) {
            return new LiveStreamHlsPlayer(this.services, gameType, videoReference, streamSource, watchTimeLimit);
        }

        return null;
    }
}
